<template>
    <v-container class="inner-main pt-2 mb-10" fluid>
        <v-row justify="start">
            <v-col lg="12">
                <v-card color="default" class="mt-2 w-100 pa-4 product-categories justify-content-center d-inline-flex"
                    elevation="0">
                    <v-menu v-if="['sm', 'xs'].includes($globalState.screenWidth)" position="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn v-bind="props" variant="text" size="large" class="mx-auto right"
                                append-icon="mdi-chevron-down">
                                {{$t('global.form.productCategories')}}
                            </v-btn>
                        </template>
                        <v-card max-height="50vh">
                            <v-list>
                                <v-list-item v-for="item in productCategories" :key="item.id"
                                    @click="$router.push(`/${selectedArea.urlName}/suche/kategorie/${item.name}/${item.name}`)">
                                    <template #title>
                                        <span>{{ item.translations[selectedLanguage.toUpperCase()].value }}</span>
                                    </template>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-menu>
                    <template v-else>

                        <v-btn variant="text" size="large" v-for="category in productCategories.slice(0, 3)"
                            :key="category.id"
                            @click="$router.push(`/${selectedArea.urlName}/suche/kategorie/${category.name}/${category.name}`)">
                            <template v-slot:prepend>
                                <CustomIcon :type="'category'" :iconName="`${category.identifier}_black`"></CustomIcon>
                            </template>
                            {{ category.translations[selectedLanguage.toUpperCase()].value }}
                        </v-btn>


                        <v-menu location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn v-bind="props" variant="text" size="large" class="mx-auto right">
                                    {{$t('main.more')}}
                                </v-btn>
                            </template>
                            <v-card max-height="500">
                                <v-list>
                                    <v-list-item
                                        @click="$router.push(`/${selectedArea.urlName}/suche/kategorie/${category.name}/${category.name}`)"
                                        v-for="category in productCategories.slice(3, productCategories.length - 1)"
                                        :key="category.id">
                                        <v-list-item-title>{{ category.translations['DE'].value }}</v-list-item-title>
                                        <template v-slot:prepend>
                                            <CustomIcon :type="'category'" :iconName="`${category.identifier}_black`">
                                            </CustomIcon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-menu>
                    </template>

                    <v-menu location="bottom" v-model="isSearchMenuOpen" :open-on-click="false">

                        <!-- <template v-slot:activator="{ props, on }">
                            <v-text-field v-on="on" v-bind="props" v-on:focus="isSearchMenuOpen = true"
                                v-on:blur="handleBlur" v-model="search" variant="outlined" density="compact"
                                :hide-details="true" @update:model-value="onSearch">
                                <template v-slot:prepend-inner>
                                    <v-icon class="">mdi-magnify</v-icon>
                                </template>
                            </v-text-field>
                        </template> -->


                        <template v-slot:activator="{ props }">
                            <v-text-field v-bind="props" @focus="isSearchMenuOpen = true" @blur="handleBlur"
                                v-model="search" :placeholder="$t('main.search.placeholder')" variant="outlined" hide-details="true"
                                density="compact" class="py-0 bg-white" height="32px"
                                @update:focused="console.log('GET BIGGER')" @update:model-value="onSearch">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-magnify"></v-icon>
                                </template>
                            </v-text-field>
                        </template>
                        <v-card v-if="search && search.length >= 2" max-height="450">
                            <v-list @update:selected="searchSelected">
                                <v-list-item v-if="searchResults.length == 0">
                                    <v-list-item-title>{{$t('main.search.noResults')}} </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-else v-for="(result, index) in searchResults" :value="result"
                                    :key="`${result.id}${index}`">
                                    <v-list-item-title>{{ result.value }} </v-list-item-title>
                                    <template v-slot:append>
                                        <span> {{ $t(`server.api.search.${result.type}`) }} </span>
                                    </template>
                                </v-list-item>
                            </v-list>

                        </v-card>
                    </v-menu>


                </v-card>
            </v-col>
        </v-row>
        <CustomSlider :count="2" :imageType="'normal'" :slides="recommendations" :customclass="'mt-5'"
            :title="$t('global.common.discover', {city:selectedArea.name})" :loadNewEntries="handleNewEntries" :follow="triggerOpenDownloadAppHint" :paginationInner="false" />

        <v-row justify="start" class="mt-4" v-if="selectedArea.districtData != null">
            <v-col lg="12">
                <v-card color="default" class="mt-2 w-100 pa-4 districts justify-content-center d-inline-flex"
                    elevation="0">
                    <v-btn variant="text" size="large"
                        v-for="district in Object.values(selectedArea.districtData).slice(0, disctrictAmount)"
                        :key="district.id"
                        @click="$router.push(`/${selectedArea.urlName}/suche/viertel/${district.name}`)">
                        {{ district.name }}
                    </v-btn>

                    <v-menu location="bottom" v-if="Object.values(selectedArea.districtData).length > 8">
                        <template v-slot:activator="{ props }">
                            <v-btn v-bind="props" variant="text" size="large" class="ml-auto">
                                {{$t('main.more')}}
                            </v-btn>
                        </template>
                        <v-card max-height="450">
                            <v-list density="compact">
                                <v-list-item
                                    @click="$router.push(`/${selectedArea.urlName}/suche/viertel/${district.name}`)"
                                    v-for="district in Object.values(selectedArea.districtData).slice(disctrictAmount, Object.values(selectedArea.districtData).length)"
                                    :key="district.id">
                                    <v-list-item-title>{{ district.name }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-menu>


                </v-card>
            </v-col>
        </v-row>

        <template v-if="events.length != 0">
            <h6 class="mt-5 " style="font-weight:700">{{ $t('global.common.events', {city:selectedArea.name}) }}</h6>
            <v-row>
                <v-col cols="12" sm="6" lg="4" v-for="(event, index) in events" :key="index">
                    <CustomImageCard :clickable="true" @click="() => triggerPostPopup(event)" :height="210"
                        :event="event" :title="event.headline" :images="event.images">
                    </CustomImageCard>
                </v-col>
            </v-row>
        </template>

        <h6 class="mt-5" style="font-weight:700"> {{$t('global.main-page.products-news')}} </h6>
        <v-row class="mx-0 mt-1 mb-2">
            <v-btn-toggle mandatory v-model="productFilter" selected-class="product-filter-selected">
                <v-btn :ripple="false" variant="text" value="all">{{$t('global.main-page.everything')}} </v-btn>
                <v-btn :ripple="false" variant="text" value="product">{{$t('global.main-page.only-products')}} </v-btn>
                <v-btn :ripple="false" variant="text" value="shops">{{$t('global.main-page.online-local')}}</v-btn>
            </v-btn-toggle>
        </v-row>
        <MasonryGrid :items="productNews" :max-columns="3" :min-columns="1">
            <!-- <template v-slot="{ item }">
                <CustomNewsCard :img="item.image" :item="item" :title="item.headline" :openPostPopup="() => openPost(item)">
                </CustomNewsCard>
            </template> -->
            <template #default="{ item }">
                <CustomNewsCard :img="item.image" :item="item" :title="item.headline"
                    :openPostPopup="() => triggerPostPopup(item)" :goToPost="() => $router.push()">
                </CustomNewsCard>
            </template>
        </MasonryGrid>
        <v-row justify="center" class="mt-3">
            <template v-if="loading">
                <v-progress-circular color="primary" indeterminate></v-progress-circular>{{$t('global.common.loading.more')}}
            </template>
            <template v-else>
                <div>
                    {{$t('global.common.loading.endOfStream')}}!
                </div>
            </template>
        </v-row>
        <div style="
        position: absolute;
        bottom: 40px;
        left: 50%;
        height: 40px;
        width: 40px;
      " v-intersect="infiniteScrolling"></div>

        <CustomTopSheetDialog v-model="showSheet" :width="600" :title="'Entdecken nach Vorteile'">
            <!-- Du hast bisher noch keine Nachrichten in deiner Inbox.
        Nach einer Anfrage kannst du hier deine Konversationen einsehen und beantworten. -->
            <v-list lines="one" active-class="">
                <v-list-item v-for="(item, index) in items" :key="index" :ripple="false" class="py-0 dialog-list-item"
                    @click="null">
                    <v-list-item-title>{{ item }}</v-list-item-title>
                    <template v-slot:append>
                        <v-icon>mdi-chevron-right</v-icon>
                    </template>
                </v-list-item>
            </v-list>
        </CustomTopSheetDialog>


    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, computed } from 'vue';
import CustomTopSheetDialog from '../custom/CustomTopSheetDialog.vue';
import CustomerSliderImage from '../custom/CustomSliderImage.vue';
import CustomNewsCard from '../custom/CustomNewsCard.vue';
import CustomSlider from '../custom/CustomSlider.vue';
import CustomImageCard from '../custom/CustomImageCard.vue';
import CustomIcon from '../custom/CustomIcon.vue';
import CustomProductLabel from '../custom/CustomProductLabel.vue';
import MasonryGrid from '../custom/MasonryGrid.vue';
import { useRouter } from 'vue-router';

export default {
    components: {
        CustomTopSheetDialog,
        CustomSlider,
        CustomerSliderImage,
        CustomNewsCard,
        CustomImageCard,
        CustomProductLabel,
        MasonryGrid
    },
    setup() {
        // const showSheet = ref(false);

        const openDownloadAppHint = inject('openDownloadAppHint')

        const triggerOpenDownloadAppHint = () => {
            if (openDownloadAppHint) {
                openDownloadAppHint();
            }
        }


        const config = {
            itemsToShow: 3
        }
        const openText = ref(false);
        const toggleText = () => {
            openText.value = !openText.value; // Toggle the open state
        }
        const { proxy } = getCurrentInstance();

        const selectedArea = inject('selectedArea')
        const selectedPost = ref(null);
        const openPostPopup = inject('openPostPopup');
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const router = useRouter();
        const disctrictAmount = computed(() => ({
            xs: 3,
            sm: 5,
            md: 7,
            lg: 8,
            xl: 9
        }[proxy.$globalState.screenWidth] || null));

        const triggerPostPopup = (item) => {
            if (openPostPopup) {
                openPostPopup(item); // Call the provided function with the `item`
            }
        }

        const postOverlay = ref(false);
        const openPost = (item) => {
            postOverlay.value = true;
            selectedPost.value = item;
        }

        // Search 

        const searchResults = ref([]);
        const search = ref('')
        const isSearchMenuOpen = ref(false)

        const onSearch = async (event) => {
            if (event.length >= 2) {
                try {
                    const response = await proxy.$axios.get("/search/keywords",
                        {
                            params: {
                                city: selectedArea.value.identifier,
                                keyword: event,
                                lang: selectedLanguage.toUpperCase()
                            }
                        },
                    );
                    if (response.data.status == "OK") {
                        searchResults.value = response.data.data;
                    }
                } catch (error) {
                    console.error("Error: ", error);
                }
            }
        }

        const handleBlur = (event) => {
            // Delay closing to check if focus moves inside the menu
            setTimeout(() => {
                isSearchMenuOpen.value = false;
                // if (!event.relatedTarget || !event.relatedTarget.closest('.search-bar')) {
                // }
            }, 200);
        };

        const searchSelected = (event) => {
            const selected = event[0]
            search.value = selected.value;
            const typeMap = {
                PRODUCT_GROUP: "produktgruppe",
                BRAND: "marke",
                DISTRICT: "viertel"
            };
            const selectedType = typeMap[selected?.type?.trim().toUpperCase()] || null;
            if (selected.type == 'SHOP_NAME') {
                router.push(`/${selectedArea.value.urlName}/laden/${selected.urlName}`)
            } else {
                router.push(`/${selectedArea.value.urlName}/suche/${selectedType}/${selected.value}`)
            }

        }

        return {
            // showSheet:false,
            config,
            openText,
            toggleText,
            postOverlay,
            openPost,
            selectedArea,
            selectedPost,
            triggerPostPopup,
            onSearch,
            searchResults,
            isSearchMenuOpen,
            handleBlur,
            searchSelected,
            search,
            selectedLanguage,
            disctrictAmount,
            triggerOpenDownloadAppHint
        };
    },

    data() {
        return {
            page: 0,
            eventPage: 0,
            totalEventPages: null,
            totalPages: null,
            sliderPage: 0,
            productFilter: 'all',
            showSheet: false,
            gridItems: [
                { text: 'Item 1', image: 'https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/c9e1454e-2e69-44ed-a188-73eb3763bfd8/STREAM' },
                { text: 'Item 2', image: 'https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/4acabd8e-d68a-4f4d-9877-bfbcef81286d/STREAM' },
                { text: 'Item 1', image: 'https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/044d898a-0f5a-4a4e-b863-cb306b51e88b/STREAM' },
                { text: 'Item 3', image: 'https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/aef76d48-79fa-4f0b-b366-b57191283d7e/STREAM' },
                { text: 'Item 2', image: 'https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/c9e1454e-2e69-44ed-a188-73eb3763bfd8/STREAM' },
                { text: 'Item 3', image: 'https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/c9e1454e-2e69-44ed-a188-73eb3763bfd8/STREAM' },
                { text: 'Item 1', image: 'https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/c9e1454e-2e69-44ed-a188-73eb3763bfd8/STREAM' },
                { text: 'Item 3', image: 'https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/aef76d48-79fa-4f0b-b366-b57191283d7e/STREAM' },
                { text: 'Item 2', image: 'https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/4acabd8e-d68a-4f4d-9877-bfbcef81286d/STREAM' },
                { text: 'Item 1', image: 'https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/044d898a-0f5a-4a4e-b863-cb306b51e88b/STREAM' },
                { text: 'Item 2', image: 'https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/c9e1454e-2e69-44ed-a188-73eb3763bfd8/STREAM' },
                { text: 'Item 3', image: 'https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/c9e1454e-2e69-44ed-a188-73eb3763bfd8/STREAM' },
                // More items here
            ],
            items: [
                "Kundenmagnet",
                "Image Booster",
                "Must-Have",
                "Geheimtipp",
                "Margen-Held",
                "PR-Star",
                "Kundenliebling",
                "Durchstarter",
            ],
            images: [
                "https://picsum.photos/200/300", "https://picsum.photos/300/300", "https://picsum.photos/500/300"
            ],

            masonryOptions: {
                itemSelector: ".masonry-item",
                columnWidth: 300,
                percentPosition: false,
                gutter: 16,
            },
            posts: [
                { image: "https://picsum.photos/300", title: "Post 1", description: "Description 1Description 1Description 1Description 1Description 1" },
                { image: "https://picsum.photos/300", title: "Post 2", description: "Description 2Description 1Description 1Description 1Description 1" },
                { image: "https://picsum.photos/300", title: "Post 1", description: "Description 1Description 1" },
                { image: "https://picsum.photos/300", title: "Post 2", description: "Description 2" },
                { image: "https://picsum.photos/300", title: "Post Post 2Post 2Post 2Post 2Post 2Post 2Post 2Post 21", description: "Description 1" },
                { image: "https://picsum.photos/300", title: "Post 2", description: "Description 2" },
                { image: "https://picsum.photos/300", title: "Post 1", description: "Description 1" },
                { image: "https://picsum.photos/300", title: "Post 2", description: "Description 2" },
                { image: "https://picsum.photos/300", title: "Post 1", description: "Description 1Description 1Description 1Description 1Description 1Description 1Description 1Description 1Description 1Description 1Description 1Description 1Description 1Description 1Description 1Description 1Description 1Description 1" },
                { image: "https://picsum.photos/300", title: "Post 2Post 2Post 2Post 2Post 2Post 2Post 2Post 2Post 2Post 2", description: "Description 2" },
                { image: "https://picsum.photos/300", title: "Post 1", description: "Description 1" },
                { image: "https://picsum.photos/300", title: "Post 2", description: "Description 2Description 1" },
                { image: "https://picsum.photos/300", title: "Post 1", description: "Description 1" },
                { image: "https://picsum.photos/300", title: "Post 2", description: "Description 2Description 1Description 1Description 1Description 1Description 1Description 1Description 1" },
            ],
            productCategories: [],
            recommendations: [],
            events: [],
            productNews: [],
            isIntersecting: false,
            loading: false,
        }
    },

    watch: {
        selectedArea(newVal, oldVal) {
            if (newVal.id != oldVal.id) {
                this.fetchRecommendations();
                this.page = 0;
                this.eventPage = 0;
                this.filtered(["event"]);
                this.filtered([]);
            }
        },
        productFilter(newVal, oldVal) {
            if (newVal != oldVal) {
                if (newVal == "all") {
                    this.page = 0;
                    this.totalPages = 0;
                    this.productNews = [];
                    this.filtered([]);
                } else if (newVal == "product") {
                    this.page = 0;
                    this.totalPages = 0;
                    this.productNews = [];
                    this.filtered(["product"]);
                } else if (newVal == "shops") {
                    this.page = 0;
                    this.totalPages = 0;
                    this.productNews = [];
                    this.fetchOnlineShops();
                }
            }
        }
    },

    mounted() {
        this.fetchProductCategories();
        if (this.selectedArea.urlName.toLowerCase() === this.$route.params.city.toLowerCase()) {
            this.fetchRecommendations();
            this.filtered(["event"]);
            this.filtered([]);
        }
    },

    methods: {
        infiniteScrolling(entries, observer, isIntersecting) {
            if (isIntersecting && this.loading == false) {

                this.loading = true;
                setTimeout(() => {
                    var _this = this;
                    if (this.page < this.totalPages) {
                        this.page++;

                        if (this.productFilter != "shops") {
                            this.$axios.post("/stream/public/v2/filtered", {
                                page: this.page,
                                resultsPerPage: 8,
                                streamFilter: {
                                    categories: this.productFilter == 'all' ? [] : ["product"],
                                    cities: [this.selectedArea.identifier]
                                }
                            })
                                .then((response) => {
                                    if (response.data.data.length > 1) {
                                        _this.productNews = [..._this.productNews, ...response.data.data]
                                        // response.data.data.forEach((item) =>
                                        // );
                                    }
                                    _this.loading = false;
                                }
                                )
                                .catch()

                        } else if (this.productFilter == "shops") {
                            this.$axios.post("/stream/public/online-shops", {
                                page: this.page,
                                resultsPerPage: 8,
                                filter: {
                                    cities: [this.selectedArea.identifier]
                                }
                            })
                                .then((response) => {
                                    if (response.data.data.length > 1) {
                                        _this.productNews = [..._this.productNews, ...response.data.data]
                                    }
                                    _this.loading = false;
                                })
                                .catch()
                        }
                    }else{
                        this.loading = false;
                    }
                }, 500);
            }
        },
        handleNewEntries() {
            this.infiniteSliding();
        },
        infiniteSliding() {
            // if (this.sliderPage < this.sliderTotalPages) {
            this.sliderPage++;

            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            var _this = this;
            this.$axios.get("/public/recommendations/shops", {
                params: {
                    city: this.selectedArea.identifier,
                    resultsPerPage: 9,
                    page: this.sliderPage,
                },
            })
                .then((response) => {
                    if (response.data.data.length > 1) {
                        _this.recommendations = [..._this.recommendations, ...response.data.data]
                        // response.data.data.forEach((item) =>
                        // );
                    }
                })
                .catch(error => {
                    
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        _this.$router.replace('/login');
                        // Optionally log the user out or redirect to login page
                    }
                });
            // }
        },
        fetchOnlineShops() {
            this.loading = true;
            this.$axios.post("/stream/public/online-shops", {
                page: this.page,
                resultsPerPage: 8,
                filter: {
                    cities: [this.selectedArea.identifier]
                }
            })
                .then(this.onlineshopsFetched)
                .catch()
        },
        onlineshopsFetched(response) {
            this.productNews = response.data.data;
            this.loading = false;
            this.totalPages = response.data.totalPages;
        },
        filtered(categories) {
            this.loading = true;
            this.$axios.post(!categories.includes('event') ? "/stream/public/v2/filtered" : "/stream/public/events", {
                page: categories.includes('event') ? this.eventPage : this.page,
                resultsPerPage: 8,
                streamFilter: {
                    cities: [this.selectedArea.identifier],
                    ...(!categories.includes('event') ? {categories: categories} : null),
                }
            })
                .then((response) => {
                    this.filteredsuccesfully(response, categories)
                }
                )
                .catch()
        },
        filteredsuccesfully(response, categories) {
            if (categories.length == 1 && categories[0] == 'event') {
                this.events = response.data.data;
                this.totalEventPages = response.data.totalPages;
            } else {
                this.productNews = response.data.data
                this.totalPages = response.data.totalPages;
            }
            this.loading = false;
            return this.productNews;
        },
        fetchProductCategories() {
            this.$axios.get("/public/data/productcategories")
                .then(this.fetchProductCategoriesFetched)
                .catch()

        },
        fetchProductCategoriesFetched(response) {
            this.productCategories = response.data.data
        },
        fetchRecommendations() {
            this.$axios.get("/public/recommendations/shops", {
                params: {
                    city: this.selectedArea.identifier,
                    resultsPerPage: 9,
                    page: this.sliderPage,
                },
            })
                .then(this.recommendationsFetched)
                .catch()
        },
        recommendationsFetched(response) {
            this.recommendations = response.data.data;
        },
    },
};
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
}

.product-categories .v-btn:hover .v-btn__content,
.districts .v-btn:hover .v-btn__content {
    text-decoration: underline;
}

.description-wrapper {
    position: relative;
}

.districts .v-btn {
    padding: 0px 8px;
    min-width: fit-content;
}

.description-text {
    display: block;
    max-height: 200px;
    /* Adjust the height based on your design */
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
    transition: max-height 0.3s ease-in-out;
    font-size: 14px;
}



.description-text:not(.truncated) {
    max-height: none;
    /* Allow full text to show when toggled */
}

.text-link {
    text-decoration: none;
    color: #1e88e5;
    cursor: pointer;
    float: right;
}

.text-link:hover {
    text-decoration: underline;
}
</style>

<style>
/*.dialog-list-item {
    min-height: 30px !important;
    background-color: transparent !important;
  }
  
  */
.v-list-item:hover {
    color: black;
}

.share-hint,
.descrption-text {
    font-size: 14px !important;
}

h1 {
    font-size: 36px !important;
    ;
}

h4 {
    font-size: 16px !important;
    font-weight: 700;
}

.f-16 {
    font-size: 16px !important;
}

.edit-btn {
    position: absolute;
    right: 15px;
    top: 15px;
    z-index: 1;
}

.logo-sheet {
    background-image: url('https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/6cc5fce5-d423-4af3-8bf8-e5d25a234e80/AVATAR');
    background-size: cover;
}

.product-filter-selected {
    text-decoration: underline;
    font-weight: 600;
}

.product-filter-selected>.v-btn__overlay {
    opacity: 0 !important;
}

.product-filter-selected:hover>.v-btn__overlay {
    opacity: 0 !important;
}

.custom-row {
    align-content: flex-start !important;
    /* Verhindert vertikale Ausrichtung */
    align-items: flex-start !important;
    /* Stellt sicher, dass alle Spalten oben beginnen */
}
</style>